var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorXRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_899_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 61C49.3447 61 63 47.3447 63 30.4999C63 13.6553 49.3447 0 32.5 0C15.6553 0 2 13.6553 2 30.4999C2 47.3447 15.6553 61 32.5 61Z",
    fill: "#D1403F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.572 59.048C44.7996 59.048 57.144 45.9389 57.144 29.7679C57.144 13.5971 44.7996 0.487999 29.572 0.487999C14.3444 0.487999 2 13.5971 2 29.7679C2 45.9389 14.3444 59.048 29.572 59.048Z",
    fill: "#E24C4B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_899_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.016 40.6483L23.4721 21.4718",
    stroke: "white",
    strokeWidth: 5.24531,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.472 40.6483L42.0159 21.4718",
    stroke: "white",
    strokeWidth: 5.24531,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_899_2031",
    x: 0.0479999,
    y: 0,
    width: 64.904,
    height: 64.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_2031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_2031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_899_2031",
    x: 18.7237,
    y: 19.035,
    width: 28.0406,
    height: 27.9541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_2031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_2031",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorXRed);
export default __webpack_public_path__ + "static/media/Icon_ErrorX_Red.0b2a8bfa743d5b2fb0bc033672928e92.svg";
export { ForwardRef as ReactComponent };